import * as React from "react";
import { forwardRef } from "react";
const SvgChartNoAxesColumn = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-chart-no-axes-column-icon lucide-chart-no-axes-column", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5 21v-6" }), /* @__PURE__ */ React.createElement("path", { d: "M12 21V3" }), /* @__PURE__ */ React.createElement("path", { d: "M19 21V9" }));
const ForwardRef = forwardRef(SvgChartNoAxesColumn);
export default ForwardRef;
